import HomeLayout from "modules/home-layout"
import useContextDashboard from "./context/dashboard"
import PreferenceContext from "hooks/preferences"
import { useAccountId } from "resources/account"
import { useMemo } from "react"
import Loading from "components/loading"
import { useClearDashboardPreferences } from "./hooks/use-clear-dashboard-preferences"

function DashboardWithPreferences({ children }) {
  // This needs to be done here it needs to be a child of the PreferenceContext.Provider for the usePreferences hook to work
  const [Context, contextValue] = useContextDashboard()

  return (
    <Context.Provider value={contextValue}>
      {children}
    </Context.Provider>
  )
}

export default function DashboardHomeLayout() {
  const accountId = useAccountId()

  // Check for clearPreferences URL param and handle clearing BEFORE any dashboard queries
  // This must be called before the PreferenceContext.Provider to ensure preferences are cleared before they are loaded
  const { isClearing: isPreferencesClearing } = useClearDashboardPreferences()

  const preferencesProps = useMemo(() => ({
    accountId,
    // Since we can only have one dashboard per account, there is no need to have a more complex key.
    // Each context will append its unique identifier to the key.
    // eg. dashboard.asset-view, dashboard.kpi, dashboard.factors-view
    key: "dashboard",
    type: "dashboard",
  }), [accountId])

  if (isPreferencesClearing) {
    return <Loading />
  }

  return (
    <PreferenceContext.Provider value={preferencesProps}>
      <DashboardWithPreferences>
        <HomeLayout />
      </DashboardWithPreferences>
    </PreferenceContext.Provider>
  )
}
